import history_icon from './history_icon.webp'
import menu_icon from './menu_icon.webp'
import plus_icon from './plus_icon.webp'
import question_icon from './question_icon.webp'
import setting_icon from './setting_icon.webp'
import bulb_icon from './bulb_icon.webp'
import compass_icon from './compass_icon.webp'
import gallery_icon from './gallery_icon.webp'
import mic_icon from './mic_icon.webp'
import user_icon from './user_icon.webp'
import youtube_icon from './youtube_icon.webp'
import message_icon from './message_icon.webp'
import code_icon from './code_icon.webp'
import send_icon from './send_icon.webp'
import gemini_icon from './gemini_icon.webp'

export const assets = {
    history_icon,
    menu_icon,
    plus_icon,
    question_icon,
    setting_icon,
    bulb_icon,
    compass_icon,
    gallery_icon,
    mic_icon,
    user_icon,
    youtube_icon,
    message_icon,
    code_icon,
    send_icon,
    gemini_icon
}